import {FrontClickEvent, Handler, HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';

/*
 * Constants.
 */

export const virtualTableHeaderRowHeight = 40; // px
export const virtualTableRowCheckboxWrapperWidth = 36; // px
export const firstElementPaddingLeft = 12; // px

export enum VirtualTableColumnCellsEnum {
  NAMESPACE = 'namespace',
  ACCOUNT = 'account',
  AVATAR = 'avatar',
  CARD = 'card',
  CUSTOM_FIELD = 'custom_field',
  DATE = 'date',
  HANDLE = 'handle',
  NUMBER = 'number',
  ICON = 'icon',
  INBOX = 'inbox',
  CHANNELS = 'channels',
  TEAMMATE = 'teammate',
  TEXT = 'text',
  CARD_GROUP = 'card_group',
  ADVANCED_NOTIFICATION_RULE = 'advanced_notification_rule',
}

export enum VirtualTableSortableColumnDirectionsEnum {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}

export const virtualTableRowBorderRadius = 12; // px
export const virtualTableRowOffset = 12; // px

export enum VirtualTableMultiSelectStatesEnum {
  UNCHECKED = 'unchecked',
  INDETERMINATE = 'indeterminate',
  CHECKED = 'checked',
}

/*
 * Interfaces.
 */

export interface HandleVirtualTableRowSelectOptions {
  isSelected: boolean;
  isInMultiSelectMode?: boolean;
  onSelect: Handler;
  onCheckBoxToggle?: HandlerOf<boolean>;
  onMultiSelect?: Handler;
}

export interface HandleVirtualTableCheckboxSelectOptions {
  isSelected: boolean;
  onCheckBoxToggle: HandlerOf<boolean>;
  onMultiSelect?: Handler;
}

/*
 * Helpers.
 */

export function computeMultiSelectCheckboxState(selectedItems: number, totalItems: number) {
  const hasSomeSelected = selectedItems > 0 && selectedItems < totalItems;
  const hasAllSelected = selectedItems > 0 && selectedItems === totalItems;

  if (hasSomeSelected) {
    return VirtualTableMultiSelectStatesEnum.INDETERMINATE;
  }

  if (hasAllSelected) {
    return VirtualTableMultiSelectStatesEnum.CHECKED;
  }

  return VirtualTableMultiSelectStatesEnum.UNCHECKED;
}

export function handleVirtualTableRowSelect(
  event: FrontClickEvent,
  options: HandleVirtualTableRowSelectOptions,
) {
  const {isSelected, isInMultiSelectMode, onCheckBoxToggle, onSelect, onMultiSelect} = options;
  if (event.defaultPrevented) {
    return;
  }
  event.preventDefault();

  // If they CMD click, treat the same as checking the checkbox.
  if (event.metaKey && onCheckBoxToggle) {
    onCheckBoxToggle(!isSelected);
    return;
  }
  // If they shift click, issue a multi select.
  if (event.shiftKey && onMultiSelect) {
    onMultiSelect();
    return;
  }
  // If we are in multi select mode, treat this as toggling the checkbox.
  if (isInMultiSelectMode && onCheckBoxToggle) {
    onCheckBoxToggle(!isSelected);
    return;
  }
  // Default to selecting the row.
  onSelect();
}

export function handleVirtualTableCheckboxSelect(
  event: FrontClickEvent,
  options: HandleVirtualTableCheckboxSelectOptions,
) {
  const {isSelected, onCheckBoxToggle, onMultiSelect} = options;
  if (event.defaultPrevented) {
    return;
  }
  event.preventDefault();

  // If they shift click, issue a multi select.
  if (event.shiftKey && onMultiSelect) {
    onMultiSelect();
    return;
  }
  // Default to checkbox toggle.
  onCheckBoxToggle(!isSelected);
}
